module.exports = __webpack_public_path__ + "static/img/TOM-EVANS.28c14af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOM-EVANS.jpg
// module id = Iex3
// module chunks = 0